module.exports = __webpack_public_path__ + "static/watching-the-english-f1846a06559cffad956a0ba1202a6131.jpg";